import React, { useState } from 'react';
import { T, LOGO_CONFIG } from '../utils/theme';
import { useAuth } from '../contexts/AuthContext';
import { auth as authAPI } from '../services/api';

const inputStyle = {
  width: '100%', padding: '14px 16px', borderRadius: 14,
  background: 'rgba(255,255,255,0.08)', border: '0.5px solid rgba(255,255,255,0.12)',
  color: '#fff', fontSize: 16, fontFamily: 'inherit', outline: 'none',
};
const labelStyle = { display: 'block', fontSize: 13, fontWeight: 600, color: 'rgba(235,235,245,0.6)', marginBottom: 6 };

const TrocaSenhaPage = () => {
  const { user, logout, concluirTrocaSenha } = useAuth();
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [erro, setErro] = useState('');
  const [salvando, setSalvando] = useState(false);

  const handleSubmit = async () => {
    setErro('');
    if (!senhaAtual || !novaSenha) { setErro('Preencha todos os campos'); return; }
    if (novaSenha !== confirmacao) { setErro('A confirmacao nao confere com a nova senha'); return; }
    setSalvando(true);
    try {
      const response = await authAPI.trocarSenha(senhaAtual, novaSenha);
      concluirTrocaSenha(response.token);
    } catch (error) {
      setErro(error.response?.data?.message || 'Nao foi possivel trocar a senha. Tente novamente.');
      setSalvando(false);
    }
  };

  const onEnter = (e) => e.key === 'Enter' && handleSubmit();

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{
      background: 'radial-gradient(1200px 700px at 20% 0%, rgba(10,132,255,0.12), transparent 60%), radial-gradient(1000px 600px at 85% 30%, rgba(191,90,242,0.08), transparent 60%), linear-gradient(180deg, #0A0A0C 0%, #060608 100%)',
    }}>
      <div style={{
        background: 'rgba(28,28,30,0.7)',
        backdropFilter: 'blur(40px) saturate(180%)', WebkitBackdropFilter: 'blur(40px) saturate(180%)',
        border: '0.5px solid rgba(255,255,255,0.1)',
        borderRadius: 28, padding: 32, width: '100%', maxWidth: 400,
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
      }}>
        <div className="text-center" style={{ marginBottom: 24 }}>
          <div style={{
            width: 64, height: 64, borderRadius: 18, background: '#fff',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 16, boxShadow: '0 8px 32px rgba(10,132,255,0.25)',
          }}>
            <img src={LOGO_CONFIG.url} alt="Barbx" style={{ width: 40, height: 40, objectFit: 'contain' }}
              onError={(e) => { e.target.style.display = 'none'; }} />
          </div>
          <h1 style={{ fontSize: 24, fontWeight: 700, color: '#fff', letterSpacing: '-0.025em' }}>Crie uma nova senha</h1>
          <p style={{ fontSize: 14, color: 'rgba(235,235,245,0.6)', marginTop: 6 }}>
            {user?.nome ? `${user.nome}, por` : 'Por'} seguranca, troque sua senha para continuar usando o sistema.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={labelStyle}>Senha atual</label>
            <input type="password" autoComplete="current-password" value={senhaAtual} disabled={salvando}
              onChange={(e) => setSenhaAtual(e.target.value)} onKeyDown={onEnter} style={inputStyle} />
            <div style={{ fontSize: 12, color: 'rgba(235,235,245,0.6)', marginTop: 6 }}>
              E a senha que voce recebeu ao ser cadastrado (normalmente 123456). Se nao funcionar, peca ao gestor para redefinir.
            </div>
          </div>
          <div>
            <label style={labelStyle}>Nova senha (minimo 6 caracteres)</label>
            <input type="password" autoComplete="new-password" value={novaSenha} disabled={salvando}
              onChange={(e) => setNovaSenha(e.target.value)} onKeyDown={onEnter} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Confirme a nova senha</label>
            <input type="password" autoComplete="new-password" value={confirmacao} disabled={salvando}
              onChange={(e) => setConfirmacao(e.target.value)} onKeyDown={onEnter} style={inputStyle} />
          </div>
          {erro && (
            <div style={{ background: 'rgba(255,59,48,0.15)', color: T.danger, padding: '12px 16px', borderRadius: 14, fontSize: 14, fontWeight: 500 }}>
              {erro}
            </div>
          )}
          <button onClick={handleSubmit} disabled={salvando} style={{
            width: '100%', padding: 15, borderRadius: 16, border: 'none',
            background: T.accent, color: '#fff', fontSize: 16, fontWeight: 600,
            fontFamily: 'inherit', cursor: salvando ? 'not-allowed' : 'pointer',
            opacity: salvando ? 0.6 : 1, boxShadow: '0 6px 20px rgba(10,132,255,0.4)',
          }}>
            {salvando ? 'Salvando...' : 'Salvar nova senha'}
          </button>
          <button onClick={logout} disabled={salvando} style={{
            width: '100%', padding: 10, border: 'none', background: 'transparent',
            color: 'rgba(235,235,245,0.6)', fontSize: 14, fontFamily: 'inherit', cursor: 'pointer',
          }}>
            Sair
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrocaSenhaPage;
